import { useOverlay } from "@toss/use-overlay";
import { ColorIcon, colors, customEvent, getCdnImageSrc, HStack, Link } from "goi_common";
import Image from "next/image";

import FileRequestModal from "@/containers/Parlor/ParlorDetailContainer/components/Modal/FileRequestModal";

export const GuidebookTipBottomFixedButtonSection = () => {
  return (
    <nav
      css={{
        position: "fixed",
        bottom: "20px",
        width: "100%",
      }}
    >
      <HStack width="100%" justifyContent="center" gap="6px">
        <GuidebookTipBottomFixedChecklistButton />
        <GuidebookTipBottomFixedQuotationButton />
      </HStack>
    </nav>
  );
};

const GuidebookTipBottomFixedChecklistButton = () => {
  const overlay = useOverlay();

  return (
    <div
      onClick={() => {
        customEvent({
          newGtm: { path: "gdb_tip", trigger_and_target: "btm_fixed_CTA-checklist" },
        });

        overlay.open(({ isOpen, close: onClose }) => {
          return <FileRequestModal path="gdb_tip" isOpen={isOpen} onClose={onClose} />;
        });
      }}
    >
      <HStack
        gap="6px"
        css={{
          justifyContent: "center",
          borderRadius: "23px",
          padding: "10px 12px",
          background: colors.white,
          color: colors.gray900,
          overflow: "hidden",
          boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.12)",
        }}
      >
        <Image
          src={getCdnImageSrc(`platform/home/match-request-version/circle-guidebook.png`)}
          alt="step-guide"
          width={22}
          height={22}
        />
        <span className="subtitle_16_sb">장례 준비 체크리스트</span>
      </HStack>
    </div>
  );
};

const GuidebookTipBottomFixedQuotationButton = () => {
  return (
    <Link
      onClick={() => {
        customEvent({
          newGtm: {
            path: "gdb_tip",
            trigger_and_target: "btm_fixed_CTA-uv_mth_req",
          },
        });
      }}
      href="/match/request/?utm_campaign=guidebook_tip_btm_fixed_button"
    >
      <HStack
        gap="6px"
        css={{
          borderRadius: "23px",
          padding: "10px 12px",
          background: colors.gray900,
          overflow: "hidden",
          cursor: "pointer",
        }}
      >
        <ColorIcon name="icon-coin-mono" color={colors.white} />
        <span className="subtitle_16_sb white">장례 견적 받기</span>
      </HStack>
    </Link>
  );
};
